import store from "../store"
import { TRIAL, TRIAL_REQUEST_PARTNERS } from "../store/data/actionTypes"

export const setTrialType = (trialType = null) => {
  store.dispatch({
    type: TRIAL,
    payload: trialType
  })
}

export const setTrialRequestPartners = (isOpen = true) => {
  store.dispatch({
    type: TRIAL_REQUEST_PARTNERS,
    payload: isOpen
  })
}

export default setTrialType